import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import type { ThirdPartyLogoProps } from '@atlassian/logo-third-party/types';

const t25IconContainerStyles = {
	small: xcss({
		width: '16px',
		height: '16px',
	}),
	medium: xcss({
		width: '24px',
		height: '24px',
	}),
	large: xcss({
		width: '32px',
		height: '32px',
	}),
	//t25 tile icons do not get bumped up to 40/48px to avoid additional padding
	xlarge: xcss({
		width: '32x',
		height: '32px',
	}),
} as const;

type Size = 'small' | 'medium' | 'large' | 'xlarge';

export interface SVGIconProps {
	glyph: (props?: Pick<ThirdPartyLogoProps, 'size'>) => JSX.Element;
	label?: string;
	size: Size;
}

const iconStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const SVGIcon = ({ glyph: SVG, label, size }: SVGIconProps): React.JSX.Element => {
	return (
		<Box
			xcss={[t25IconContainerStyles[size], iconStyles]}
			aria-label={label || undefined}
			role={label ? 'img' : 'presentation'}
		>
			{fg('rovo-search-team-eu-26-brand-icon-library') ? (
				<SVG size={size === 'small' ? 'xxsmall' : size === 'medium' ? 'small' : 'medium'} />
			) : (
				<SVG />
			)}
		</Box>
	);
};
